var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPortalMei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3093",
    "data-name": "Grupo 3093",
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 25,
    viewBox: "0 0 185 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M169.232.086l6.679,1.834a1.638,1.638,0,0,1,1.247,1.52V21.874a1.653,1.653,0,0,1-1.34,1.545l-6.679,1.521a1.8,1.8,0,0,1-2.332-1.545V1.605a1.812,1.812,0,0,1,2.424-1.52",
    transform: "translate(-141.62 0)",
    fill: "#fec654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M83.445,18.809l6.679,1.834a1.637,1.637,0,0,1,1.247,1.52V36.135a1.653,1.653,0,0,1-1.34,1.545L83.353,39.2a1.8,1.8,0,0,1-2.332-1.545V20.328a1.812,1.812,0,0,1,2.424-1.52",
    transform: "translate(-68.787 -16.252)",
    fill: "#e9655f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M2.424,28,9.1,29.835a1.638,1.638,0,0,1,1.247,1.52V42.541a1.653,1.653,0,0,1-1.34,1.545L2.332,45.607A1.8,1.8,0,0,1,0,44.062V29.52A1.812,1.812,0,0,1,2.424,28",
    transform: "translate(0 -24.231)",
    fill: "#58c5c6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M300.938,42.69a3.9,3.9,0,0,1-1.736,3.425,8.637,8.637,0,0,1-4.92,1.191h-2.725v6.365h-1.23V38.264h4.317q6.294,0,6.294,4.426m-9.381,3.688h2.423a8.2,8.2,0,0,0,4.3-.859,3.072,3.072,0,0,0,1.326-2.788,2.979,2.979,0,0,0-1.254-2.64,6.962,6.962,0,0,0-3.882-.859h-2.918Z",
    transform: "translate(-246.488 -33.214)",
    fill: "#002c43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M387.946,72.464a5.963,5.963,0,0,1-1.555,4.379,5.759,5.759,0,0,1-4.293,1.575,6.174,6.174,0,0,1-3.038-.727,4.879,4.879,0,0,1-2.014-2.087,6.77,6.77,0,0,1-.7-3.14A5.925,5.925,0,0,1,377.9,68.1a5.748,5.748,0,0,1,4.268-1.565,5.629,5.629,0,0,1,4.238,1.586,5.983,5.983,0,0,1,1.537,4.347m-10.345,0a5.316,5.316,0,0,0,1.188,3.683,4.924,4.924,0,0,0,6.716,0,5.317,5.317,0,0,0,1.188-3.683,5.239,5.239,0,0,0-1.2-3.678,4.346,4.346,0,0,0-3.37-1.307,4.278,4.278,0,0,0-3.346,1.3,5.306,5.306,0,0,0-1.176,3.683",
    transform: "translate(-319.519 -57.751)",
    fill: "#002c43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M479.745,66.531a11.7,11.7,0,0,1,1.784.148l-.229,1a7.954,7.954,0,0,0-1.7-.179,3.467,3.467,0,0,0-2.749,1.244,4.635,4.635,0,0,0-1.073,3.14v6.323h-1.194V66.752H475.6l.12,2.066h.084a5.111,5.111,0,0,1,1.724-1.776,4.492,4.492,0,0,1,2.218-.511",
    transform: "translate(-402.922 -57.751)",
    fill: "#002c43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M528.427,60.717a10.213,10.213,0,0,0,1.978-.169v.843a7.172,7.172,0,0,1-2,.253,3.531,3.531,0,0,1-2.562-.812,3.445,3.445,0,0,1-.826-2.55v-7.4h-1.941v-.611l1.941-.474.6-2.592h.615v2.772h3.846v.906h-3.846v7.251a2.99,2.99,0,0,0,.531,1.95,2.052,2.052,0,0,0,1.664.632",
    transform: "translate(-444.09 -40.977)",
    fill: "#002c43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M590.035,78.346l-.3-1.813h-.1a5.417,5.417,0,0,1-4.5,2.023,4.668,4.668,0,0,1-3-.864,3.04,3.04,0,0,1,.524-5,9.687,9.687,0,0,1,4.624-.98l2.5-.063V70.9a3.546,3.546,0,0,0-.76-2.466,3.171,3.171,0,0,0-2.448-.832,9.122,9.122,0,0,0-3.774.885l-.446-.906a11.191,11.191,0,0,1,4.269-.885,4.631,4.631,0,0,1,3.225.98,3.96,3.96,0,0,1,1.067,3.056v7.619Zm-4.823-.738a4.888,4.888,0,0,0,3.31-1.049,3.648,3.648,0,0,0,1.212-2.914V72.519l-2.291.084a9.7,9.7,0,0,0-3.937.754,2.111,2.111,0,0,0-1.176,1.986,2.007,2.007,0,0,0,.754,1.67,3.357,3.357,0,0,0,2.128.6",
    transform: "translate(-493.324 -57.89)",
    fill: "#002c43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 1.194,
    height: 16.398,
    transform: "translate(101.441 4.059)",
    fill: "#002c43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M746.544,35.478a6.114,6.114,0,0,1,2.46.453,4.691,4.691,0,0,1,1.857,1.549h.073q-.073-1.328-.073-2.6v-4.12h1.182v16.4h-.784l-.3-1.749h-.1a5.075,5.075,0,0,1-4.292,1.96,5.524,5.524,0,0,1-4.148-1.475,5.923,5.923,0,0,1-1.435-4.3,6.543,6.543,0,0,1,1.423-4.542,5.3,5.3,0,0,1,4.136-1.57m0,.948a3.925,3.925,0,0,0-3.225,1.317,5.908,5.908,0,0,0-1.08,3.826q0,4.869,4.329,4.869a4.225,4.225,0,0,0,3.256-1.128,5.424,5.424,0,0,0,1.037-3.72v-.179a5.763,5.763,0,0,0-1.019-3.82,4.171,4.171,0,0,0-3.3-1.165",
    transform: "translate(-629.097 -26.698)",
    fill: "#002c43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M847.308,72.464a5.962,5.962,0,0,1-1.556,4.379,5.758,5.758,0,0,1-4.293,1.575,6.173,6.173,0,0,1-3.038-.727,4.878,4.878,0,0,1-2.014-2.087,6.769,6.769,0,0,1-.7-3.14,5.926,5.926,0,0,1,1.555-4.368,5.748,5.748,0,0,1,4.268-1.565,5.628,5.628,0,0,1,4.238,1.586,5.981,5.981,0,0,1,1.537,4.347m-10.346,0a5.317,5.317,0,0,0,1.188,3.683,4.924,4.924,0,0,0,6.716,0,5.319,5.319,0,0,0,1.187-3.683,5.238,5.238,0,0,0-1.2-3.678,4.345,4.345,0,0,0-3.37-1.307,4.278,4.278,0,0,0-3.346,1.3,5.306,5.306,0,0,0-1.176,3.683",
    transform: "translate(-709.518 -57.751)",
    fill: "#002c43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M982.308,53.67,977.2,40.8h-.1q.206,2.867.205,5.375V53.67h-2.617V38.263h4.063l4.9,12.256h.072l5.041-12.256h4.075V53.67h-2.773V46.051q0-1.149.066-2.993t.115-2.234h-.1L984.853,53.67Z",
    transform: "translate(-827.511 -33.213)",
    fill: "#002c43"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M1130.186,53.67h-9.972V38.263h9.972v2.129h-7.09v4.194h6.643v2.108H1123.1v4.837h7.09Z",
    transform: "translate(-951.062 -33.214)",
    fill: "#002c43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 2.882,
    height: 15.407,
    transform: "translate(182.118 5.05)",
    fill: "#002c43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPortalMei);
export default __webpack_public_path__ + "static/media/logo-portal-MEI.53826768457b28b43c2f2a6e2c11ad84.svg";
export { ForwardRef as ReactComponent };